import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, Button } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { set, getUploadFileInfo } from "./attachedfileSlice";
import Chip from "@material-ui/core/Chip";
import * as uploadfileApi from "../../utils/uploadfile";
import {
  setContent as setSnackContent,
  setLevel,
  setOpen as SnackOpen,
} from "../snackAlert/snackAlertSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    margin:"auto",
    width:"100%",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  button: {
    color: red[50],
    backgroundColor: red["A700"],
  },
  chipdecor: {
    color: red["A700"],
    border: "1px solid",
    borderColor: red["A700"],
    "& > svg": {
      color: red["A700"],
    },
    //backgroundColor: red["A700"],
  },
}));

export function Attachedfile() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [buttonState, setButtonState] = useState("initial");
  const allowedFileSize = 5 * 1024 * 1024;
  const classes = useStyles();
  const dispatch = useDispatch();
  const uploadfileinfo = useSelector(getUploadFileInfo);
  const initialContent = (
    <div className={classes.root}>
      <input
        accept="image/*,.pdf"
        className={classes.input}
        id="contained-button-file"
        multiple={false}
        type="file"
        onChange={(e) => {
          if (e.target.files.length > 0) {
            if (e.target.files[0].size <= allowedFileSize) {
              let name = e.target.files[0].name;
              let newObj = {};
              newObj["FileName"] = name;
              newObj["FileSize"] = e.target.files[0].size;
              setSelectedFile(e.target.files[0]);
              dispatch(set(newObj));
              setButtonState("attachedfile");
              console.log("attached file: ", newObj);
            } else {
              dispatch(SnackOpen(true));
              dispatch(setSnackContent("Attached file size is too large!!"));
              dispatch(setLevel("error"));
            }
          }
        }}
      />
      <label htmlFor="contained-button-file">
        <Button fullWidth variant="contained" className={classes.button} component="span">
          ATTACHED FILE
        </Button>
      </label>
    </div>
  );
  const handleDelete = () => {
    setSelectedFile(null);
    setButtonState("initial");
  };
  const UploadFile = (
    <div>
      <Chip
        label={selectedFile?.name || ""}
        onDelete={handleDelete}
        className={classes.chipdecor}
        variant="outlined"
      />
    </div>
  );
  useEffect(() => {
    if (buttonState === "initial") {
      setContent(initialContent);
    } else if (buttonState === "attachedfile") {
      setContent(UploadFile);
    }
  }, [buttonState]);

  useEffect(() => {
    //console.log(uploadfileinfo);
    if (uploadfileinfo != null && uploadfileinfo !== undefined)
      if (
        uploadfileinfo["fileguid"] != null &&
        uploadfileinfo["fileguid"] !== undefined
      ) {
        let formData = new FormData();
        formData.append('file',selectedFile);
        formData.append("fileguid", uploadfileinfo["fileguid"]);
        formData.append("firstname", uploadfileinfo["firstname"]);
        formData.append("lastname", uploadfileinfo["lastname"]);
        uploadfileApi.uploadfile(formData).then((msg)=>{console.log(msg);window.location.reload(false)}).catch((msg)=>console.log(msg));
        
      }
  }, [uploadfileinfo]);

  const [content, setContent] = useState(initialContent);
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return <React.Fragment> {content}</React.Fragment>;
}
